import * as React from "react";
import {IReadGalleryResponse} from "../../core/api/post/response/ReadGalleryResponse";

interface IProps {
    data: IReadGalleryResponse;
}

interface IState {
    menuItem: {}
}

export class GalleryGridItem extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            menuItem: {}
        }
    }

    public render() {
        return (
            <div className="post-prev-img">
                <a className="lightbox-gallery-2 mfp-image" href={this.props.data.image}>
                    <img src={this.props.data.image} />
                    <br />
                    {this.props.data.description}
                </a>
            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./src/component/gallery/GalleryGridItem.tsx